import { provideRedux } from '@reduxjs/angular-redux';
import { createStore } from '@store/create-store';
import { productionDependencies } from '@configurations/dependencies/prod.dependencies';
import { provideHttpClient } from '@angular/common/http';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { ErrorHandler, importProvidersFrom } from '@angular/core';
import { RumErrorHandler } from '@app/rum-error-handler';
import { MatDialogModule } from '@angular/material/dialog';
import { HeaderModule, TileModule } from '@totalenergiescode/tds-angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { AppRoutingModule } from '@app/app-routing.module';

import { SecurityModule } from '@app/security/security.module';
import { CommonModule } from '@angular/common';
import { HomepageModule } from '@app/homepage/homepage.module';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { MsalModule } from '@azure/msal-angular';
import { ScenarioModule } from '@app/scenarios/scenario.module';
import { AdminModule } from '@app/admin/admin.module';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AppComponent } from '@app/app.component';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

const store = createStore(productionDependencies);

bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(MatDialogModule, TileModule, FormsModule, ReactiveFormsModule, BrowserModule, AppRoutingModule, SecurityModule, CommonModule, HomepageModule, RouterOutlet, HeaderModule, RouterLink, RouterLinkActive, MsalModule, ScenarioModule, AppRoutingModule, AdminModule, MatMenuModule, MatIconModule, MatTooltipModule),
        provideRedux({ store }),
        provideAnimationsAsync(),
        provideHttpClient(),
        { provide: MAT_DATE_LOCALE, useValue: navigator.language },
        { provide: ErrorHandler, useClass: RumErrorHandler },
    ]
})
  .catch(err => console.error(err));


